import { IconProps } from "./IconProps";

const SendToMobileIcon: React.FC<IconProps> = ({
  width = 30,
  height = 30,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M17 16L15.6 14.6L17.15 13H12V11H17.15L15.6 9.4L17 8L21 12L17 16ZM7 23C6.45 23 5.97917 22.8042 5.5875 22.4125C5.19583 22.0208 5 21.55 5 21V3C5 2.45 5.19583 1.97917 5.5875 1.5875C5.97917 1.19583 6.45 1 7 1H17C17.55 1 18.0208 1.19583 18.4125 1.5875C18.8042 1.97917 19 2.45 19 3V7H17V6H7V18H17V17H19V21C19 21.55 18.8042 22.0208 18.4125 22.4125C18.0208 22.8042 17.55 23 17 23H7Z"
        fill={color}
      />
    </svg>
  );
};
export default SendToMobileIcon;
